<template dark>
    <div class="renderPage">
        <v-toolbar color="primary" dark elevation="1" class="mb-1 mb-md-2 mb-lg-2">
            <v-spacer />
            <v-toolbar-title class="text-capitalize">
                Saldo Balance
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon color="white" @click="close()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container>
            <v-row>
                <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="editedItem.saldo" label="Saldo" class="pa-0" readonly></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="editedItem.flotante" label="Saldo Flotante" class="pa-0"
                        readonly></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-text-field v-model="editedItem.limite" label="Saldo Limite" class="pa-0" readonly></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
    components: {
        Snackbar,
    },
    dark: true,
    data() {
        return {
            dialog: false,
            show3: false,
            valid: false,
            guardarValid: true,
            snackText: "",
            snackValue: false,
            editedIndex: -1,
            editedItem: {
                id: 0,
                companyId: "",
                idUsuario: "",
                saldo: 0,
                flotante: 0,
                limite: 0,
            },
            showNewData: false,
            nameRules: [(v) => !!v || "Campo requerido"],
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        search() {
            this.snackValue = false;
        },
    },

    created() {
        this.editedItem = Object.assign({}, this.editedItem);
        this.getData();
    },

    methods: {
        getData() {
            let me = this;
            axios
                .get("api/Tiempos/GetSaldoBalance?idUsuario=" + this.user.cedula +
                    "&companyId=" +
                    this.strCia, {
                    crossdomain: true,
                })
                .then(function (response) {
                    me.editedItem = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
};
</script>

<style>
.cd {
    overflow: scroll;
}

.v-tabs-items {
    overflow: auto;
}

.botonSalir {
    position: fixed;
    top: 5px;
    right: 5px;
}
</style>